// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1CePL","right":"styles_right__3iD2P"};